import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { getApiBaseUrl, type ApiBaseUrlEnv } from '@/shared/api/getApiBaseUrl'
import { setAdminToken } from './adminApi'

export function AdminLogin() {
  const navigate = useNavigate()
  const [secret, setSecret] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    const trimmed = secret.trim()
    if (trimmed.length < 24) {
      setError('Ключ не короче 24 символов (как на сервере в ADMIN_SECRET).')
      return
    }
    setBusy(true)
    try {
      const base = getApiBaseUrl(import.meta.env as unknown as ApiBaseUrlEnv, window)
      const res = await fetch(`${base}/api/admin/stats/summary`, {
        headers: {
          Authorization: `Bearer ${trimmed}`,
          'Content-Type': 'application/json',
        },
      })
      if (!res.ok) {
        const t = await res.text()
        setError(t.slice(0, 200) || `Ошибка ${res.status}`)
        return
      }
      setAdminToken(trimmed)
      navigate('/admin/dashboard', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-700 bg-slate-900 p-8 shadow-xl">
        <h1 className="text-xl font-bold text-white">Админ-панель</h1>
        <p className="mt-2 text-sm text-slate-400">
          Доступ по секрету из переменной окружения{' '}
          <code className="rounded bg-slate-800 px-1 text-slate-200">ADMIN_SECRET</code> на сервере API.
          Ключ хранится только в памяти вкладки (sessionStorage).
        </p>
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="admin-secret" className="block text-sm font-medium text-slate-300">
              Секретный ключ
            </label>
            <input
              id="admin-secret"
              type="password"
              autoComplete="off"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-600 bg-slate-950 px-3 py-2 text-white placeholder:text-slate-600 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              placeholder="Вставьте ADMIN_SECRET"
            />
          </div>
          {error ? <p className="text-sm text-red-400">{error}</p> : null}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-lg bg-indigo-600 py-2.5 font-semibold text-white hover:bg-indigo-500 disabled:opacity-50"
          >
            {busy ? 'Проверка…' : 'Войти'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-500">
          <Link to="/login" className="text-indigo-400 hover:underline">
            Обычный вход в приложение
          </Link>
        </p>
      </div>
    </div>
  )
}
